var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-responsive',_vm._b({style:({
    'background-image': 'url(' + _vm.imgSrc + ')',
    'background-size': 'cover',
    'background-position': 'center'
  }),attrs:{"aspect-ratio":1 / 1.41421356}},'v-responsive',{
    width: _vm.isImgFixed && _vm.$vuetify.breakpoint.mdAndUp ? '200px' : 'auto'
  },false),[(_vm.hoverEvent)?_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var hover = ref.hover;
return _c('v-responsive',{attrs:{"height":"100%"}},[_c('vc-share-a',_vm._b({attrs:{"href":_vm.contentUrl}},'vc-share-a',{ target: _vm.targetBlank ? '_blank' : '_self' },false),[_c('div',{staticClass:"d-flex",style:({
            'background-color': hover
              ? 'rgba(255,255,255,0.5)'
              : 'rgba(255,255,255,0)',
            height: '100%'
          })},[(_vm.displayIcon)?[_c('v-responsive',{staticClass:"ma-auto",attrs:{"height":"36%","width":"60%","max-width":"60%","aspect-ratio":2 / 1.7}},[_c('div',{staticClass:"d-flex",style:({ height: '100%' })},[_c('v-responsive',{staticClass:"text-xs-center",style:({
                    display: 'flex',
                    'align-items': 'center'
                  }),attrs:{"max-width":"100%"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.fadeOutFlag)?_c('v-img',{staticClass:"d-inline-block",attrs:{"src":_vm.playIcon,"width":"55px"}}):_vm._e()],1)],1)],1)])]:_vm._e()],2)])],1)}}])}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }